<template>
    <div>
        <ToolBar
            :menu="'Tiếp nhận dữ liệu QLNT'"
            :content="'Cấu hình lịch đồng bộ'"
            :subContent="'Cấu hình lịch đồng bộ cấp Sở'"
            :hideToggle="true"
        >
        </ToolBar>
        <CustomTable
            :tableData="tableData"
            :hidePagi="true"
            :hide-btn-table="true"
            :title="'Cấu hình năm học cấp sở'"
        >
            <template v-slot:title-actions>
                <!-- <CustomButton label="Tìm kiếm" @click="handleSearch" /> -->
                <CustomButton label="Thêm mới" @click="openModalAddNew" />
            </template>
            <template v-slot:header>
                <tr class="text-center">
                    <th>STT</th>

                    <th>Năm học</th>
                    <th>Ngày bắt đầu</th>
                    <th>Ngày kết thúc</th>
                    <th>Ngày cập nhật</th>
                    <th>Trạng thái</th>
                    <th>Thao tác</th>
                </tr>
            </template>
            <template v-slot:body>
                <tr
                    v-for="(item, index) in tableData"
                    :key="index"
                    class="text-center"
                >
                    <td>
                        {{ index + 1 }}
                    </td>

                    <td>{{ item.namHoc }} - {{ item.namHoc + 1 }}</td>
                    <td>{{ item.dauNamTuNgay }}</td>

                    <td>{{ item.dauNamToiNgay }}</td>
                    <td>{{ item.updatedTime }}</td>
                    <td>
                        <TextStatus
                            :content="
                                item.status === 1
                                    ? 'Đang hoạt động'
                                    : 'Ngưng hoạt động'
                            "
                            :status="item.status"
                        />
                    </td>
                    <td>
                        <span v-if="item.status === 1">
                            <CustomToolTip content="Khóa">
                                <img
                                    :src="iconLock"
                                    class="icon"
                                    @click="openModalStatus(item)"
                                />
                            </CustomToolTip>
                        </span>
                        <span v-else @click="openModalStatus(item)">
                            <CustomToolTip content="Mở khóa">
                                <img
                                    :src="iconUnLock"
                                    class="icon"
                                    @click="openModalStatus(item)"
                                />
                            </CustomToolTip>
                        </span>
                        <span>
                            <CustomToolTip content="Chỉnh sửa">
                                <img
                                    :src="iconEdit"
                                    class="icon"
                                    @click="openModalEdit(item)"
                                /> </CustomToolTip
                        ></span>
                    </td>
                </tr>
            </template>
        </CustomTable>
        <CustomModal
            :centered="true"
            :is-modal-visible.sync="statusVisible"
            :modal-title="'Thông báo'"
            :close-function="closeModalStatus"
        >
            <template v-slot:content>
                <div>
                    {{ status.status === 1 ? 'Sau khi khóa, không thể chỉnh sửa lịch đồng bộ và thao tác nộp dữ liệu từ phía quản lý nhà trường. Bạn có chắc muốn khóa?' : 'Xác nhận mở khóa lịch đồng bộ' }}
                </div>
            </template>

            <template v-slot:btn-handle>
                <CustomButton :label="status.status === 1 ? 'Khóa' : 'Mở khóa'" @click="handleChangeStatus" />
            </template>
        </CustomModal>
        <ModalAddNew
            :closeModalAddNew="closeModalAddNew"
            :addNewVisible="addNewVisible"
            @handleSearch="handleSearch"
        />
        <ModalEdit
            :closeModalEdit="closeModalEdit"
            :editVisible="editVisible"
            @handleSearch="handleSearch"
            :dataEdit="dataEdit"
        />
    </div>
</template>

<script>
import ToolBar from '@/components/ToolBar.vue'
import CustomTable from '@/components/CustomTable.vue'
import CustomButton from '@/components/CustomButton.vue'
import { getFromSessionStorage } from '@/utils/session'

import sendRequest from '@/services'
import Api from '@/constants/Api'
import CustomModal from '@/components/CustomModal.vue'
import { showNotication, showColoredNotification } from '@/utils/notification'
import ModalAddNew from './modal_add.vue'
import ModalEdit from './modal_edit.vue'
import iconEdit from '@/assets/img/icon-table/edit.svg'
import iconLock from '@/assets/img/icon-table/lock.svg'
import iconUnLock from '@/assets/img/icon-table/un-lock.svg'
import CustomToolTip from '@/components/CustomToolTip.vue'
import TextStatus from '@/components/TextStatus.vue'
export default {
    name: 'DepartmentLevel',

    components: {
        ToolBar,
        CustomTable,
        CustomButton,
        CustomModal,
        ModalAddNew,
        ModalEdit,
        CustomToolTip,
        TextStatus
    },
    data() {
        return {
            iconEdit,
            iconLock,
            iconUnLock,

            tableData: [],
            statusVisible: false,
            status: { idStatus: null, textStatus: null, status: null },
            addNewVisible: false,

            editVisible: false,
            dataEdit: {}
        }
    },
    methods: {
        openModalStatus(item) {
            this.status.status = item.status
            this.status.idStatus = item.id
            this.status.textStatus = item.status === 1 ? 'Khóa' : 'Mở khóa'
            this.statusVisible = true
        },
        closeModalStatus() {
            this.statusVisible = false
        },

        async handleChangeStatus() {
            try {
                const request_data = {
                    idSo: this.auth_user.ma_so,
                    status: this.status.status === 1 ? 0 : 1,
                    id: this.status.idStatus,
                    namHoc: this.selectedYearFromStore
                }
                const response = await sendRequest(
                    Api.tiep_nhan_du_lieu_QLNT.cau_hinh_lich_dong_bo
                        .thay_doi_trang_thai_cap_so,
                    request_data,
                    this.request_headers
                )
                if (response.rc == 0) {
                    await this.handleSearch()

                    // Option 1: Using custom CSS class
                    if (this.status.status === 1) {
                        // Lock action - red/warning color
                        showNotication(
                            this,
                            'warning',
                            'Khóa lịch đồng bộ thành công',
                            { customClass: 'notification-lock' }
                        )
                    } else {
                        // Unlock action - custom green color #c9ffe5
                        showNotication(
                            this,
                            'success',
                            'Mở khóa lịch đồng bộ thành công',
                            { customClass: 'notification-unlock' }
                        )
                    }

                    this.statusVisible = false
                } else {
                    showNotication(this, 'error', response.rd)
                }
            } catch (error) {
                console.log(error)
            }
        },
        openModalAddNew() {
            this.addNewVisible = true
        },
        closeModalAddNew() {
            this.addNewVisible = false
        },
        openModalEdit(item) {
            this.editVisible = true
            this.dataEdit = item
        },
        closeModalEdit() {
            this.editVisible = false
        },
        async handleSearch() {
            try {
                const request_params = {
                    idSo: this.auth_user.ma_so,
                    namHoc: this.selectedYearFromStore
                }
                const response = await sendRequest(
                    Api.tiep_nhan_du_lieu_QLNT.cau_hinh_lich_dong_bo.cap_so,
                    null,
                    this.request_headers,
                    request_params
                )
                this.tableData = response.tableData
            } catch (error) {
                console.log(error)
            }
        }
    },
    mounted() {
        this.handleSearch()
    },
    computed: {
        selectedYearFromStore() {
            return this.$store.state.selectedYear.selectedYear
        },

        auth_user() {
            return getFromSessionStorage('auth_user')
        },
        request_headers() {
            return {
                token: this.auth_user.token
            }
        }
    }
}
</script>

<style scoped></style>
